import React, { useState, useRef } from "react";

export function useInlineQuantityEdit<T extends { quantity?: number }>(
  onSetQuantity: (item: T, quantity: number) => void
) {
  const [editingKey, setEditingKey] = useState<string | number | null>(null);
  const [inputValue, setInputValue] = useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);

  const startEdit = (item: T, itemKey: string | number, isDisabled: boolean) => {
    if (isDisabled) return;
    setEditingKey(itemKey);
    setInputValue(String(item?.quantity ?? ""));
    setTimeout(() => {
      inputRef.current?.select();
    }, 0);
  };

  const commitEdit = (item: T) => {
    const parsed = parseInt(inputValue, 10);
    if (!isNaN(parsed) && parsed >= 1) {
      onSetQuantity(item, parsed);
    }
    setEditingKey(null);
    setInputValue("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, item: T) => {
    if (e.key === "Enter") {
      commitEdit(item);
    } else if (e.key === "Escape") {
      setEditingKey(null);
      setInputValue("");
    }
  };

  return {
    editingKey,
    inputValue,
    inputRef,
    setInputValue,
    startEdit,
    commitEdit,
    handleKeyDown,
  };
}
